import React from 'react'
import MessengerCustomerChat from 'react-messenger-customer-chat'

const MessengerCustomerChatWrapper = () => {
  return (
    <>
      {/* Messenger */}
      <MessengerCustomerChat
        pageId="106606437990901"
        appId="256616849223777"
        language="pl_PL"
      />
    </>
  )
}

export default MessengerCustomerChatWrapper
